exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-container .block-container{float:none;width:100%;margin:0;box-shadow:0 5px 15px rgba(0,0,0,.05)}.list-container .block-container h2{font-size:1.7rem;font-weight:400}", ""]);

// exports
